<template>
  <div class='technology-exploit-indication-table-cell'>
    <div v-if='versionExist'>
      <span class='technology-exploit-indication-table-cell__true' v-if='indication'>
        <span class="material-icons">
          circle
        </span>
      </span>
      <span class='technology-exploit-indication-table-cell__false' v-else>
        <span class='material-icons'>
          circle
        </span>
      </span>
    </div>
    <div class='technology-exploit-indication-table-cell__empty' v-else>
      <span class="material-icons-outlined">
          clear
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TechnologyExploitIndicationTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    indication() {
      return this.item[this.column.field] || false;
    },
    versionExist() {
      return this.item.versions.some(version => version !== 'N/A') || false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.technology-exploit-indication-table-cell {
  width: 100%;
  display: flex;
  justify-content: center;

  &__true {
    .material-icons {
      color: var(--severity-critical);
      font-size: $font-size-md;
    }
  }

  &__false {
    .material-icons {
      color: var(--severity-low);
      font-size: $font-size-md;
    }
  }

  &__empty {
    margin-top: rem(6);

    .material-icons-outlined {
      color: var(--text-muted);
    }
  }
}
</style>
